import { useState, useEffect } from "react";

function useWindowSize() {
  const isWindowClient = typeof window === "object";

  const [windowSize, setWindowSize] = useState(
    isWindowClient ? window.innerWidth && window.innerHeight : undefined
  );

  useEffect(() => {
    // handler for the window size
    function handleResize() {
      // update width and height state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    handleResize();

  }, [isWindowClient, setWindowSize]);
  return windowSize;
}

export default useWindowSize;
